import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const ExtensionsIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#383838';
  return <Icon name={'extensions'} size={size} color={color} />;
};

export default React.memo(ExtensionsIcon);
